import { useState } from 'react';
import ContentBlocks from '../components/ContentBlocks';
import NavButtons from '../components/NavButtons';

const LETTERS = 'abcdefghijklmnopqrstuvwxyz'.split('');

function normalizeAnswer(str) {
  return str.toLowerCase().replace(/[^a-z ]/g, '');
}

export default function HangmanScreen({ blocks, question, correctAnswer, hangmanImages = [], onBack, onNext, showBack = true }) {
  const [guessedLetters, setGuessedLetters] = useState(new Set());

  const answer = normalizeAnswer(correctAnswer);
  const answerLetterSet = new Set(answer.replace(/ /g, '').split(''));

  const wrongGuesses = [...guessedLetters].filter(l => !answerLetterSet.has(l));
  const isComplete = [...answerLetterSet].every(l => guessedLetters.has(l));

  const currentImage = hangmanImages.length > 0
    ? hangmanImages[Math.min(wrongGuesses.length, hangmanImages.length - 1)]
    : null;

  function handleGuess(letter) {
    if (guessedLetters.has(letter) || isComplete) return;
    setGuessedLetters(prev => new Set([...prev, letter]));
  }

  return (
    <div className="screen">
      <div className="screen-content">
        <ContentBlocks blocks={blocks} />
        {currentImage && (
          <img src={currentImage} alt="hangman" className="hangman-visual" />
        )}
        <p className="puzzle-question">{question}</p>
        <p className="hangman-wrong-count">Wrong guesses: {wrongGuesses.length}</p>
        <div className="hangman-phrase">
          {answer.split(' ').map((word, wi) =>
            <span key={wi} className="hangman-word">
              {word.split('').map((char, ci) =>
                <span key={ci} className="hangman-letter">
                  {guessedLetters.has(char) ? char : '\u00a0'}
                </span>
              )}
            </span>
          )}
        </div>
        <div className="hangman-keyboard">
          {LETTERS.map(letter => {
            const guessed = guessedLetters.has(letter);
            const correct = guessed && answerLetterSet.has(letter);
            const wrong = guessed && !answerLetterSet.has(letter);
            return (
              <button
                key={letter}
                className={`btn hangman-key ${correct ? 'btn-primary' : 'btn-secondary'} ${wrong ? 'hangman-key--wrong' : ''}`}
                onClick={() => handleGuess(letter)}
                disabled={guessed || isComplete}
              >
                {letter}
              </button>
            );
          })}
        </div>
      </div>
      <NavButtons onBack={onBack} onNext={onNext} showBack={showBack} nextDisabled={!isComplete} />
    </div>
  );
}
